import Enumeration from 'Lib/utilities/Enumeration';

const ContactTypes = new Enumeration([
	{ id: 1, key: 'Owner', name: 'Owner', url: `/contacts/owners`, color: '#4666c0' },
	{ id: 2, key: 'Tenant', name: 'Tenant', url: `/contacts/tenants`, color: '#f74a30' },
	{ id: 3, key: 'Vendor', name: 'Vendor', url: `/maintenance/vendors`, color: '#00a499' },
	{ id: 4, key: 'Manager', name: 'Management Company', url: `/contacts/owners`, color: '#50C878' },
	{ id: 5, key: 'Association', name: 'Association', url: `/associations`, color: '#c62e6a' },
	{ id: 6, key: 'Applicant', name: 'Applicant', color: '#00a499' },
	{ id: 7, key: 'TenantProspect', name: 'Tenant Prospect', color: '#00a499' }
]);

export default ContactTypes;
